import { render, staticRenderFns } from "./third.vue?vue&type=template&id=0a77ae4e&scoped=true"
import script from "./third.vue?vue&type=script&lang=js"
export * from "./third.vue?vue&type=script&lang=js"
import style0 from "./third.vue?vue&type=style&index=0&id=0a77ae4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a77ae4e",
  null
  
)

export default component.exports